import Vue from 'vue'
import { Popover, Tag } from 'ant-design-vue'
import _ from 'lodash'

Vue.use(Popover)
Vue.use(Tag)

export default Vue.extend({
  template: `
        <div>
          <div v-if="list.split(',').length > 2" style="margin-top: -3px;">
            <span v-for="(keyword, index) in list.split(',')" :key="index">
              <a-tag color="#71283e" v-if="index < 2" style="margin-top: 4px">
                {{ keyword }}
              </a-tag>
            </span>
            <a-popover title="Keywords" trigger="hover">
              <template slot="content">
                <div class="pb-1" v-for="(keyword, index) in list.split(',')" :key="index">
                  <a-tag color="#71283e">{{ keyword }}</a-tag>
                </div>
              </template>
              <a-tag color="transparent" class="more-tag">
                + {{ list.split(",").length - 2 }} More
              </a-tag>
            </a-popover>
          </div>
          <div v-else style="margin-top: -3px;">
            <div v-if="list">
              <a-tag v-for="(keyword, index) in list.split(',')" :key="index" color="#71283e" style="margin-top: 4px">
                {{ keyword }}
              </a-tag>
            </div>
          </div>
        </div>
      `,
  data: function() {
    return {
      list: [],
    }
  },
  beforeMount() {
    this.list = _.get(this.params, 'value', '')
  },
})
